import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/src/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fr },
    current: 'fr'
  },
  theme: {
    themes: {
      light: {
        primary: '#00A0D1',
        secondary: '#78BE20',
        info: '#006DB2',
        success: '#78BE20',
        warning: '#FC961E',
        error: '#DF382B'
      }
    }
  }
});
